// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"6572":"virtuoso","8428":"00f2183e","9911":"apex-charts"}[chunkId] + ".050687234529a32a.js";
};